module.exports = __webpack_public_path__ + "2370bc96eae74de3cc0cadce64e83d75.jpg";